import * as Yup from 'yup'

import { type StopAppointment } from 'core/appointments/domain/Appointment'

import { hasAppointmentChanged } from '../../../domain/Appointment'
import { type AppointmentFormValues } from '../../../infra/ShipmentRepository'
import { militaryTimeSchema, MILITARY_TIME_REGEX } from './utils'

const timeValidation = militaryTimeSchema('Time')

export const defaultValidationSchema = {
  mode: Yup.string().required(),
  type: Yup.string().required(),
  loadingType: Yup.string().required(),
  notifyShipper: Yup.boolean().nullable(),
  date: Yup.string().required(),
  time: timeValidation.required(),
  timeType: Yup.object().shape({
    label: Yup.string().required(),
    value: Yup.string().required(),
  }),
  timeEnd: Yup.string()
    .nullable()
    .when('timeType.value', {
      is: (val: string) => val === 'between',
      then: schema =>
        schema
          .required('End time required')
          .test('military-format-end', 'End time must be HHMM (0000–2359)', value =>
            Boolean(value && MILITARY_TIME_REGEX.test(value))
          )
          .test('order', 'Time start must be less than end time', function (value) {
            const start = this.resolve(Yup.ref('time'))
            if (!value || !start) return true
            return Number(start) < Number(value)
          }),
      otherwise: schema => schema.notRequired(),
    }),
  confirmationNumber: Yup.string().max(255),
}

export function getScheduledValidationSchema(appointment?: StopAppointment) {
  if (!appointment) {
    return Yup.object(defaultValidationSchema)
  }

  return Yup.object({
    ...defaultValidationSchema,
    misschedulingReason: Yup.object()
      .nullable()
      .test('validateSchedulingReason', 'Reschedule reason required', function (value) {
        const appointmentChanged = hasAppointmentChanged(
          this.options.context as AppointmentFormValues,
          appointment
        )
        const { label } = (value as { label: string; value: string }) || {}
        if (!label && appointmentChanged) return false
        if (!label && appointment.status === 'confirmed') return false
        return true
      }),
    misschedulingNote: Yup.string().when('misschedulingReason.value', {
      is: (val: string) => val === 'other',
      then: schema => schema.required('Note is a required field'),
      otherwise: schema => schema.notRequired(),
    }),
  })
}
